import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../../models/form-control.model';
import { ErrorMessageModel } from '../../models/error-message.model';

@Component({
    selector: 'aur-textarea',
    template: `<mat-form-field [formGroup]="formGroup" fxFlex>
    <span *ngIf="control.prefix" matPrefix>{{ control.prefix }}</span>

    <textarea matInput
        matTextareaAutosize
        [formControlName]="control.name"
        [readonly]="control.isReadonly"
        [placeholder]="control.placeholder"
        [required]="control.isRequired"
        [maxlength]="control.maxLength"
        [minlength]="control.minLength">
    </textarea>

    <span *ngIf="control.suffix" matSuffix>{{ control.suffix }}</span>

    <mat-hint *ngIf="control.maxLength" align="end">
        {{ formGroup.controls[control.name].value.length }} / {{ control.maxLength }}
    </mat-hint>

    <mat-error>
        {{ getErrorMessage() }}
    </mat-error>
</mat-form-field>`
})
export class TextareaComponent {

    @Input() formGroup: FormGroup;
    @Input() control: AurFormControl;

    getErrorMessage(): string {
        return (<AurFormControl>this.formGroup.controls[this.control.name]).errorMessages
            .filter((errorMessage: ErrorMessageModel) => this.formGroup.controls[this.control.name].hasError(errorMessage.type))
            .map((errorMessage: ErrorMessageModel) => errorMessage.text)[0];
    }
}
